module.exports = __webpack_public_path__ + "static/media/pusins_with_budget.9d0d8801.gif";